define('shared/util/state/adapters/persistent',[
    'shared/lib/store',
    'shared/lib/RSVP'
],
function ( store, RSVP ) {

    var KEY_STATE = 'persistent';
    var KEY_STORE = 'state_persistent';
    var state;
    var storeData;
    var stateData;
    var nextTick;
    var undef;

    function isExpired(item) {
        var now = new Date();
        if ( 
            item &&
            item.date && 
            item.date.expiration && 
            typeof item.date.expiration.getTime === 'function' &&
            now - item.date.expiration >= 0 
        ) {
            return true;
        }

        return false
    }

    // extend object to make it convertable to primitive
    function extendObject(ret){
        ret.valueOf = function () {
            return ret.value.valueOf();
        };
        ret.toString = function () {
            return ret.value.toString();
        };
    }

    function monitorNextExpiration() {
        if ( stateData == null || nextTick != null ) {
            return;
        }

        var closestDate;
        var closestItem;
        var closestKey;
        var cur;
        var key;

        for ( key in stateData ) {
            cur = stateData[key];
            if ( cur.date == null || cur.date.expiration == null ) {
                continue;
            }
            if ( closestDate == null || closestDate - cur.date.expiration > 0) {
                closestDate = cur.date.expiration;
                closestItem = cur;
                closestKey = key;
            }
        }

        if ( closestDate == null ) {
            return;
        }

        nextTick = setTimeout( function(){
            state
                .put(KEY_STATE + '.' + closestKey, undef)
                .then(function(){
                    nextTick = null;
                    monitorNextExpiration();
                });
        }, closestDate - (new Date()) );
    }

    function store2state(data){
        var ret = {};
        var key, item;
        var now = new Date();
        var tmp;

        for( key in data ) {
            item = data[key];

            if ( item == null || item.tick == null ) {
                continue;
            }

            tmp = unzip(item);

            if ( isExpired(tmp) ) {
                continue;
            }

            ret[key] = tmp;

        }

        return ret;
    }

    function state2store(data) {
        var ret = {};
        var key, item;
        var tmp;

        for( key in data ) {
            item = data[key];

            if ( item == null ) {
                continue;
            }

            if ( isExpired(item) ) {
                continue;
            }

            tmp = zip(item);

            ret[key] = tmp;

        }

        return ret;
    }

    function unzip(item){

        var ret = {
            date: {}
        };

        if ( item.tick.expiration ) {
            ret.date.expiration = new Date(item.tick.expiration);
        }

        if ( item.tick.creation ) {
            ret.date.creation = new Date(item.tick.creation);
        }

        if ( item.tick.modification ) {
            ret.date.modification = new Date(item.tick.modification);
        }

        ret.value = item.value;
        extendObject(ret);

        return ret;
    }

    function zip( item ) {
        var ret = {
            tick: {}
        };
        var now = new Date();

        if ( item.date && 
            item.date.expiration && 
            typeof item.date.expiration.getTime === 'function' 
        ) {
            ret.tick.expiration = item.date.expiration.getTime();
        }

        if ( 
            item.date && 
            item.date.creation &&
            typeof item.date.creation.getTime === 'function' 
        ) {
            ret.tick.creation = item.date.creation.getTime();
        }
        else {
            ret.tick.creation = now.getTime();
        }

        ret.tick.modification = now.getTime();

        ret.value = item.value;

        return ret;
    }

    var adapter = {
        "init": function( stateObject ) {
            state = stateObject;

            if ( storeData == null ) {
                storeData = store.get(KEY_STORE);
            }

            stateData = store2state( storeData );
            monitorNextExpiration();

            return state.put( KEY_STATE, stateData );
        },

        "isApplicable" : function (key) {
            return key && (key.split(".")[0] === KEY_STATE);
        },

        "afterPut" : function (state, key, item) {
            if ( key == KEY_STATE ) {
                for( var subKey in data ) {
                    if ( !data.hasOwnProperty(subKey) ) {
                        continue;
                    }
                    state.put( KEY_STATE + '.' + key, data[ subKey ] );
                }
            }
            else {
                var storeKey = key.split('.')[1];

                if ( storeKey == null ) {
                    throw new Error('Key is empty');
                }

                if ( item && item.value != null ) {
                    // update stateData
                    stateData[storeKey] = item;
                    extendObject(item);
                }
                else {
                    delete stateData[storeKey];
                }

                monitorNextExpiration();

                // sync to store
                storeData = state2store(stateData);
                store.set ( KEY_STORE, storeData );
            }
        }
    };

    return adapter;
});

